/**
 * Re-starts the marquee after a product swap.
 *
 * FavMarquee (global.js) does its whole setup -- cloning the items, measuring them, setting
 * the animation duration and adding .active -- from a DOMContentLoaded listener registered in
 * its constructor. It has to: on a normal page load the constructor runs while the parser is
 * still inside the element, so there is nothing to measure yet.
 *
 * The flavor switcher replaces <main> long after that event has fired, so the fresh marquee
 * upgrades, registers a listener for an event that will never come again and stays at
 * opacity 0 -- the section reads as an empty coloured band. Its children do exist by then,
 * though, so setup can simply be run here.
 *
 * This file is loaded by the section itself, inside <main>, which is what gets it re-executed
 * on every swap: the swap re-creates the <script> tags it replaces.
 */
(() => {
    // Before load the element's own listener is still coming, and running now would clone the
    // items a second time. Only a marquee that arrived after the document finished is orphaned.
    if (document.readyState !== 'complete') return;

    document.querySelectorAll('fav-marquee').forEach((marquee) => {
        // .active means it has been through setup already -- including the outgoing copy of
        // the section, which stays in the document for a moment after the swap.
        if (marquee.classList.contains('active')) return;
        if (typeof marquee.initialize !== 'function') return;
        if (!marquee.items?.length || !marquee.wrapper) return;

        marquee.initialize();
    });
})();
